import type { CurationReviewRow } from '@avisoma/shared';
import { formatDateTime } from '../../lib/dateFormat';
import { CURATION_SOURCE_LABELS } from '../../lib/curationSourceLabels';

export function CurationVerdictRow({ verdict }: { verdict: CurationReviewRow }) {
  const reverted = verdict.revertedAt !== null;
  const corrected = verdict.verdict === 'corrected';

  return (
    <li className={`flex gap-2.5 text-sm ${reverted ? 'opacity-50' : ''}`}>
      <span
        className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-[10px] font-bold text-white ${
          corrected ? 'bg-blue-500' : 'bg-green-500'
        }`}
        aria-hidden
      >
        {corrected ? '↪' : '✓'}
      </span>
      <div className="min-w-0">
        <div className={`text-gray-900 dark:text-zinc-100 ${reverted ? 'line-through' : ''}`}>
          {corrected ? (
            <>
              <span className="font-medium">Corrected</span> {verdict.oldCategory ?? '—'} →{' '}
              {verdict.newCategory ?? '—'}
            </>
          ) : (
            <>
              <span className="font-medium">Confirmed</span> {verdict.oldCategory ?? 'current category'}
            </>
          )}
          {reverted && (
            <span className="ml-1.5 inline-block rounded bg-red-100 px-1.5 py-0.5 text-[10px] font-semibold text-red-800 no-underline dark:bg-red-900/40 dark:text-red-300">
              reverted
            </span>
          )}
        </div>
        <div className="mt-0.5 text-xs text-gray-500 dark:text-zinc-400">
          <span className="rounded bg-gray-100 px-1.5 py-0.5 font-medium dark:bg-zinc-700">
            {CURATION_SOURCE_LABELS[verdict.source]}
          </span>{' '}
          · {verdict.reviewerName ?? verdict.reviewerId} · {formatDateTime(verdict.createdAt)}
        </div>
      </div>
    </li>
  );
}
